import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_parse_and_insert_response_request_payload_to_stagingService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { payload: string, storageMessageId?: string, storageTransactionId?: string }): Promise<{ outputDetails?: string[], debugDetails?: string[], success?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.payload)) {
      missingRequiredInParams.push('\'payload\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/parse_and_insert_response_request_payload_to_staging`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

